import React, { useState } from 'react';

import BaseBarChart from './BaseBarChart';

import ModalStateLess  from '../ModalStateLess';


const renderCustomBarLabel = ({ x, y, width, height, index, value }) => {
	const textColor = '#000';
	return (
		<text
			x={x + width / 2}
			y={y + height / 2}
			dy={5}
			fill={textColor}
			font-weight="bold"
			style={{ fontSize: `14px` }}
		>
			{String(value).padStart(2, '0')}
		</text>
	);
};

const CustomTooltip = ({ active, payload, label, prefix = '' }) => {
	// console.log('CustomTooltip payload[0]: ', payload[0])
	if (active && payload && payload.length) {
		return (
			<div className="custom-tooltip" style={{ backgroundColor: '#fff', borderRadius: 5, padding: '10px', border: '1px solid #ccc' }}>
				<p className="label" style={{ fontSize: 14 }}>{label}:  {String(payload[0].value).padStart(2, '0')}</p>
				{/* <p className="list" style={{ fontSize: 12, marginTop: 5 }}>Tickets: {payload[0].payload.list.join(', ')}</p> */}
			</div>
		);
	}

	return null;
};

const CustomYAxisTick = ({ x, y, payload }) => (
	<g transform={`translate(${x},${y})`}>
		<text
			x={0}
			y={0}
			dy={16}
			textAnchor="end"
			verticalAnchor="middle"
			fill="#666"
			// font-size="6px"
			style={{ fontSize: `19px` }}
		>
			{payload.value}
		</text>
	</g>
);

const AnalisttTicketCounter = ({ data }) => {

	// console.log('AnalisttTicketCounter DATA: ', data)

	const [chartData, setChartData] = useState(data || []);
	const [showModal, setShowModal] = useState(false);
	const [modalContent, setModalContent] = useState(null);

	React.useEffect(() => {
		const tempData = data.map((item) => ({
			yKey: item.nome,
			xKey: item.tickets_finalizados.length,
			list: item.tickets_finalizados.map(tk => String(tk.cod_id).padStart(3, '0') + " - " + tk.titulo)
		}));
		setChartData(tempData.sort((a, b) => b.xKey - a.xKey));
	}, [data]);


	return (

		// <div className="w-[100%] ticket-counter min-h-[300px] px-4 bg-red-500">
		<div className='card' style={{ width: '100%', maxWidth: '100%', display: 'flex', flexDirection: 'column' }}>
			<ModalStateLess
				show={showModal}
				content={modalContent}
				hideModal={() => setShowModal(false)}
			/>
			<BaseBarChart
				title="Tickets finalizados por analista"
				data={chartData}
				xKey="xKey"
				yKey="yKey"
				height={500}

				tooltip={<CustomTooltip prefix="Tickets: " />}
				onBarClick={(data, index, event) => {
					const content = <div>
						<h2 style={{ fontSize: 16, fontWeight: 'bold', marginBottom: 10 }}>Tickets finalizados por {data.payload.yKey}</h2>
						{data.payload.list.length === 0 ? (
							<div style={{ fontSize: 14, marginBottom: 5 }}>Nenhum ticket finalizado.</div>
						) : (
							data.payload.list.map((ticket, i) => (
								<div key={i} style={{ fontSize: 14, marginBottom: 5 }}>
									{ticket}
								</div>
							))
						)}
					</div>;
					setModalContent(content);
					setShowModal(true);
				}}
				xAxisProps={{ type: 'number', domain: [0, 'dataMax + 1'], tickCount: 6 }}
				yAxisProps={{
					type: 'category',
					tickLine: false,
					tickFormatter: () => '',
					tick: <CustomYAxisTick />
				}}
				barGap={60}
				margin={{ top: 20, right: 30, left: 100, bottom: 5 }}

				gridProps={{ strokeDasharray: "" }}

				bars={[
					{
						dataKey: "xKey",
						color: "#1A5BDA",
						radius: [0, 5, 5, 0],
						barSize: 60,
						label: renderCustomBarLabel
					}
				]}
			/>
		</div>
	);
};

export default AnalisttTicketCounter;
